/* Ordinia: "Complementa tu pedido" — añade la variante sugerida al carrito en un clic.
   Usa la API de carrito del tema y su evento de actualización para refrescar carrito y mini-carrito. */
(function () {
  if (window.__ordComp) return;
  window.__ordComp = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-ord-comp-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;

    var box = btn.closest('[data-ord-comp]');
    var error = box && box.querySelector('[data-ord-comp-error]');
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: Number(btn.getAttribute('data-quantity')) || 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return import('@theme/events').then(function (mod) {
          btn.dispatchEvent(new mod.CartAddEvent(cart, 'ordinia-complementa', {
            source: 'ordinia-complementa',
            itemCount: cart.item_count,
            variantId: String(variantId)
          }));
          // Fuera del carrito (p. ej. en la ficha) el botón no se vuelve a pintar: se libera y confirma.
          btn.removeAttribute('aria-busy');
          var done = btn.getAttribute('data-done-label');
          if (done) btn.textContent = done;
        }).catch(function () {
          window.location.reload();
        });
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        if (error) error.hidden = false;
      });
  });
})();
